import {api} from "@/store/api";

export default {
  state: {
    favoriteHnl: [],
    favoriteHomes: [],
    favoriteHnlDetail: [],
  },
  getters: {
    favoriteHnlIds: (state) => {
      const list = localStorage.getItem('runwayhnllist');
      if (list) {
        return list.split(',');
      }
      return [];
    },

    favoriteHnl: (state) => {
      return state.favoriteHnl
    },
    favoriteHnlDetail: (state) => {
      return state.favoriteHnlDetail
    },
    favoriteHomes: (state) => {
      return state.favoriteHomes
    }
  },
  mutations: {
    setFavoriteHnl(state, payload) {
      state.favoriteHnl = payload
    },

    setFavoriteHnlDetailList(state, payload) {
      state.favoriteHnlDetail = payload
    },

    setFavoriteHome(state, payload) {
      state.favoriteHomes = payload
    }
  },
  actions: {
    removeFavoritesHnl({dispatch, commit, state}, id) {
      const list = localStorage.getItem('runwayhnllist');
      if (list) {
        const listArray = list.split(',');
        const index = listArray.indexOf(id);
        if (index > -1) {
          listArray.splice(index, 1);
          const runwayhnllist = listArray.join(',');
          localStorage.setItem('runwayhnllist', runwayhnllist);
          commit('setFavoriteHnl', listArray);
          const hnlIndex = state.favoriteHnlDetail.findIndex(item => item.cpidstring === id);
          if (hnlIndex > -1) {
            state.favoriteHnlDetail.splice(hnlIndex, 1);
            commit('setFavoriteHnlDetailList', state.favoriteHnlDetail);
          }
        }
      }
    },

    setFavoriteHnl({dispatch, commit, state}, id) {
      const list = localStorage.getItem('runwayhnllist');
      if (list) {
        const listArray = list.split(',');
        if (listArray.includes(id)) {
          return;
        } else {
          listArray.push(id);
          commit('setFavoriteHnl', listArray)
          const runwayhnllist = listArray.join(',');
          localStorage.setItem('runwayhnllist', runwayhnllist);
        }
      } else {
        commit('setFavoriteHnl', [id]);
        localStorage.setItem('runwayhnllist', id);
      }
    },

    setFavoriteHome({dispatch, commit, state}, id) {
      const list = localStorage.getItem('runwayhomes');
      if (list) {
        const listArray = list.split(',');
        if (listArray.includes(id)) {
          return;
        } else {
          listArray.push(id);
          commit('setFavoriteHome', listArray)
          const runwayhnllist = listArray.join(',');
          localStorage.setItem('runwayhomes', runwayhnllist);
        }
      } else {
        commit('setFavoriteHome', [id]);
        localStorage.setItem('runwayhomes', id);
      }
    },

    fetchAllFavoritePackageDetail({dispatch, commit, state}, payload) {
      const list = localStorage.getItem('runwayhnllist');
      if (list) {
        const listArray = list.split(',');
        listArray.forEach(id => {
          const hnl = state.favoriteHnlDetail.findIndex(hnl => hnl.cpidstring === id);
          if (hnl < 0) {
            dispatch('getFavoritePackageDetail', id)
          }
        })
      }
    },

    setFavoritePackageDetail({dipatch, commit, state}, payload) {
      const index = state.favoriteHnlDetail.findIndex(item => item.cpidsstrin === payload.cpidstring);
      if (index < 0) {
        state.favoriteHnlDetail.push(payload);
        commit('setFavoriteHnlDetailList', state.favoriteHnlDetail);
      }
    },

    getFavoritePackageDetail({dispatch, commit, state}, id) {
      api.getPackageDetail(id).then(res => {
        dispatch("setFavoritePackageDetail", res.data)
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/favorite.js